import InfoSection from "../components/info_section";
import ScrollButton from "../components/scroll_button";
import Layout from "../components/layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { i18n, useTranslation } from "next-i18next";
import styles from "../styles/database.module.scss";
import { useState } from "react";
import Image from "next/image";

export default function Databases() {
  const router = useRouter();
  const { t } = useTranslation("databases");
  const [clicked, setIsClicked] = useState(-1);

  return (
    <Layout
      title={t("title")}
      lang={router.locale}
      route={router.route}
      isHeader
      isFooter
    >
      <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
      <InfoSection
        title="Database"
        description="databasesDescription"
        documentationLink="https://help.icdc.io/database/"
        lang={router.locale}
      />
      <section className={"flex " + styles.key_features}>
        <div className={styles.container}>
          <div className={styles.features}>
            <h2>{t("key_features.title")}</h2>
            {new Array(3).fill("").map((_, key) => (
              <div key={key}>
                <h3>{t(`key_features.feature${key + 1}_title`)}</h3>
                <span>{t(`key_features.feature${key + 1}_desc`)}</span>
                <br />
                {key === 1 && (
                  <span className={styles.second_li}>
                    {t(`key_features.feature${key + 1}_desc${key + 1}`)}
                  </span>
                )}
              </div>
            ))}
          </div>
          <Image src="/key_features.webp" alt={t("keyFeaturesAlt")} width={876} height={581} unoptimized loading='lazy' />
        </div>
      </section>

      <section className={"flex " + styles.use_cases}>
        <h2>{t("use_cases.title")}</h2>
        <p className={styles.p_desc}>{t("use_cases.desc")}</p>
        <div className={styles.desc}>
          {new Array(6).fill("").map((_, key) => (
            <div key={key}>
              <img src={`/icons/use_cases${key + 1}.svg`} alt={t("useCasesAlt")} />
              <p>
                <b>{t(`use_cases.title${key + 1}`) + " "}</b>
                {t(`use_cases.desc${key + 1}`)}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className={"flex " + styles.how_it_works}>
        <h2>{t("how_it_works.title")}</h2>
        <div className={styles.how_it_works_img}>
          <Image
          src={i18n.language === "en" ? "/database_en.webp" : "/database_ru.webp"}
          alt="Database"
            width={1543}
            height={463}
            unoptimized loading='lazy'
        />
        </div>
      </section>

      <section className={"flex " + styles.security}>
        <h2>{t("security.title")}</h2>
        <p className={styles.desc}>{t("security.desc")}</p>
        <div className={styles.container}>
          {new Array(4).fill("").map((_, key) => (
            <div key={key} className={styles.item}>
              <p>
                <b>
                  {t(`security.title${key + 1}`)}
                  <br />
                </b>
                {t(`security.desc${key + 1}`)}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.faq}>
        <h2>{t("faq.title")}</h2>
        <div className={styles.faq_wrapper}>
          {new Array(8).fill("").map((_, key) => (
            <button
              className={styles.faq_container}
              onClick={() =>
                clicked !== key ? setIsClicked(key) : setIsClicked(-1)
              }
              key={key}
            >
              <div className={styles.faq_titles + ' ' + (clicked === key ? styles.active : '')}>
                <b className={styles.title}>{t(`faq.title${key + 1}`)}</b>
                <img
                  className={
                    clicked !== key ? styles.purple_plus : styles.purple_minus
                  }
                  src={clicked !== key ? "/plus.svg" : "/minusFAQ.svg"}
                  alt="FAQ"
                />
              </div>
              {clicked === key && (
                <p className={styles.faq_answ}>{t(`faq.desc${key + 1}`)}</p>
              )}
            </button>
          ))}
        </div>
      </section>
    </Layout>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["databases", "common"])),
  },
});
